import { RESET_GLOBAL_STATE, ResetGlobalState, UNKNOWN, Unknown } from './types';

export const resetGlobalState = (): ResetGlobalState => ({
  type: RESET_GLOBAL_STATE,
});

export const unknown = (): Unknown => ({
  type: UNKNOWN,
});

export default {
  resetGlobalState,
  unknown,
};
